// access to the course
export const ENROLLED = 'Enrolled'
export const SIGNED_UP = 'Signed Up'
export const PRE_DROP = 'PreDrop'
export const A = 'A'
export const A_MINUS = 'A-'
export const B_PLUS = 'B+'
export const B = 'B'
export const B_MINUS = 'B-'
export const C_PLUS = 'C+'
export const C = 'C'
export const C_MINUS = 'C-'
export const D = 'D'
export const F = 'F'
export const CONTENT = 'Content'
export const COMPLETED = 'Completed'

// no access to any assessments
export const AUDIT = 'Audit'
export const AUDIT_TRANSCRIPT = 'Audit Transcript'
export const WITHDRAW = 'Withdraw'

// no access to the course
export const MELT = 'Melt'
export const DROP = 'Drop'
export const ADMINISTRATIVE_DROP = 'Administrative Drop'
export const UNOFFICIAL_WITHDRAW = 'Unofficial Withdraw'
export const NO_ACCESS_STUDENT_STATUSES = [
  MELT, DROP, ADMINISTRATIVE_DROP, UNOFFICIAL_WITHDRAW
]
export const ACTIVE_STATUSES = [
  SIGNED_UP, PRE_DROP, AUDIT, AUDIT_TRANSCRIPT, ENROLLED
]

export const DROP_NR = 'DropNR'
export const GRADE_NOT_APPLICABLE = [
  MELT, DROP, ADMINISTRATIVE_DROP, DROP_NR
]
export const NEEDS_REVIEWING = 'Needs Reviewing'
export const NEEDS_REVIEWING_DEGREE = 'Needs Reviewing - Degree'

export const NO_EXTENSION_MODAL_REQUEST = [
  AUDIT, AUDIT_TRANSCRIPT, WITHDRAW
]
